import { OrganisationRoutes } from './organisation';
import { UserManagementRoutes } from './user';
import { RoleManagementRoutes } from './role';
import { SingleSignOnRoutes } from './singleSignOn';
import { LeaverRuleRoutes } from './leaverRule';
import { ExternalAPIKeyManagementRoutes } from './externalAPIKeyManagement';
import { DocuSignRoutes } from './docuSign';
import { Configuration } from '@/types';
import ConfigurationTreeView from '@/components/configuration/TreeView.vue';
import { CabinetConfigurationRoutes } from './cabinet';
import { TreeViewConstants } from '@/types/constants/TreeViewConstants';
import { TaskServicesRoutes } from './taskServices';
import { ScriveRoutes } from './scrive';
import { DocumentEncryptionRoutes } from './documentEncryption';
import { ExceptionalJobsRoutes } from './exceptionalJobs';
import { ListMaintenanceRoutes } from './listMaintenance';
import { XPorterRoutes } from './xPorter';

const ConfigurationDashboard = () =>
  import(
    /* webpackChunkName: "configuration" */
    '@/views/configuration/ConfigurationDashboard.vue'
  );

export const ConfigurationRoutes = [
  {
    ...Configuration.Base,
    components: {
      default: ConfigurationDashboard,
      treeView: ConfigurationTreeView
    },
    meta: {
      layout: 'TreeView',
      treeViewKey: TreeViewConstants.Keys.Configuration,
      title: 'Configuration Dashboard'
    }
  },
  ...OrganisationRoutes,
  ...UserManagementRoutes,
  ...RoleManagementRoutes,
  ...SingleSignOnRoutes,
  ...LeaverRuleRoutes,
  ...DocuSignRoutes,
  ...CabinetConfigurationRoutes,
  ...TaskServicesRoutes,
  ...ScriveRoutes,
  ...DocumentEncryptionRoutes,
  ...ExceptionalJobsRoutes,
  ...ListMaintenanceRoutes,
  ...XPorterRoutes,
  ...ExternalAPIKeyManagementRoutes
];
